export default __webpack_public_path__ + "static/media/img-rotate-clock.d3190030.svg";